import { CustomHookProps, useBasicMutation } from '@napa/react-core';
import { User } from 'types/users';

export default function useUpdateUser(userId: string, props?: CustomHookProps<User>): any {
  return useBasicMutation<User>({
    apiRoute: `users/${userId}`,
    httpMethod: 'PUT',
    isFormData: false,
    params: props,
  });
}
